// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__RxjH0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Y_IRu"};